import {
  ICON_MENU,
  ICON_BASKET,
  ICON_LOGIN_GRAY,
  ICON_LOGOUT_GRAY,
  ICON_WhatApps,
} from "../../utils/useIcons";

import { BlueButton } from "../../components/attributes/Button";
import {
  STYLE_ARROW_RED,
  STYLE_BG_NAVBAR,
  STYLE_BODY_3_REGULAR,
  STYLE_FLEX_MENU_NAVBAR,
  STYLE_FLEX_NAVBAR_DESKTOP,
  STYLE_HEADING_3,
  STYLE_HEADING_3_BOLD_24_18,
  STYLE_HEADING_3_BOLD_24_18_TH,
  STYLE_HEADING_3_TH,
  STYLE_HOVER_BLUE,
  STYLE_LOCATION_NAVBAR,
  STYLE_LOCATION_NAVBAR_PLACEHOLDER,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_NAVBAR_LOGO,
  STYLE_NAVBAR_MOBILE,
  STYLE_PADDING_WINDOWS,
  STYLE_PARENT_DELETE_PROGRAM,
  STYLE_PARENT_PANEL_MODAL,
  STYLE_VIEWBOX_ICON,
} from "../../utils/useStyle";
import { useNavigate, useLocation } from "react-router-dom";
import { ContextLanguage } from "../../context/Context.Language";
import React from "react";
import DrawerMain from "../drawer/Drawer.Main";
import {
  TEXT_ADDRESS_SEARCH,
  TEXT_ARE_YOU_SURE_LOGOUT,
  TEXT_CANCEL,
  TEXT_CREATE_ORDER,
  TEXT_LOG_OUT,
} from "../../utils/useConstants";
import { useIsMobile } from "../../utils/useIsMobile";
import { useDispatch, useSelector } from "react-redux";
import { OnClickLogout } from "../../utils/useFunction";
import { ContextCart } from "../../context/Context.Cart";
import TemplateModal from "../template/Template.Modal";
import NavbarSerachLocation from "./render/Navbar.SearchLocation";
import { FunctionCloneDeep, FunctionOpenInNewTab } from "radium-omnibus";
import {
  StoreSelectedLocation,
  SystemStoreBasketAddress,
} from "../../utils/useStorage";
import AddressOnClickCurrentLocation from "../../pages/address/functions/Address.OnClickCurrentLocation";

const FunctionGetHistory = (location) => {
  const redirect = sessionStorage.getItem("redirect-keep-history");

  if (redirect?.length > 0) {
    let temp = FunctionCloneDeep(JSON.parse(redirect));
    temp.push(location.pathname);
    // let temp2 = temp.slice(-2);

    sessionStorage.setItem("redirect-keep-history", JSON.stringify(temp));
    // sessionStorage.setItem("redirect-back-to", temp2[0]);
    // sessionStorage.setItem
  } else {
    sessionStorage.setItem(
      "redirect-keep-history",
      JSON.stringify([location.pathname])
    );
  }
};

const Notification = ({ count = 0, onClick = () => {} }) => {
  const { language } = React.useContext(ContextLanguage);
  if (count > 0) {
    return (
      <div
        onClick={() => {
          onClick();
        }}
        className=" absolute top-1 right-1 cursor-pointer "
      >
        <div class=" rounded-full relative h-4.5 w-4.5 bg-laundry-red-100 border-2 border-white  ">
          <div
            className={`${
              language === "TH" ? " mt-[1px] -ml-[0.5px] " : " "
            } text-9 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white font-semibold text-center `}
          >
            {count}
          </div>
        </div>
      </div>
    );
  } else {
    return <React.Fragment />;
  }
};

const DesktopNavbar = React.memo(({ refScreen, isNotCompleteProfile }) => {
  const { cart } = React.useContext(ContextCart);
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = React.useState(false);
  const { user, loading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const isAddress = location.pathname === "/Address";
  const { language, ContextRenderChangeLanguage } =
    React.useContext(ContextLanguage);

  const [openLogout, setOpenLogout] = React.useState(false);

  const isBasket = location.pathname === "/Basket";

  const setSelectedLocation = StoreSelectedLocation(
    (state) => state.setSelectedLocation
  );

  const address = SystemStoreBasketAddress((state) => state.address);
  const setAddress = SystemStoreBasketAddress((state) => state.setAddress);

  // console.log("address", address);

  React.useEffect(() => {
    if (!address) {
      AddressOnClickCurrentLocation(false, setSelectedLocation, setAddress);
    }
  }, [address]);

  return (
    <div className={STYLE_BG_NAVBAR}>
      <div className={`${STYLE_MAX_WIDTH_DESKTOP} ${STYLE_PADDING_WINDOWS} `}>
        <div ref={refScreen} className={STYLE_FLEX_NAVBAR_DESKTOP}>
          <div
            className={` flex md:w-[233px] lg:w-[315px] xl:w-menu_search  items-center `}
          >
            <div className={STYLE_VIEWBOX_ICON}>
              <ICON_MENU
                className={`${STYLE_HOVER_BLUE} w-[23px] cursor-pointer  text-laundry-gray-100 `}
                onClick={() => {
                  if (!isNotCompleteProfile) {
                    setOpen(true);
                  }
                }}
              />
            </div>
            <DrawerMain open={open} setOpen={setOpen} />
            {/* <div className="  ">
              <NavbarSerachLocation
                className={`${STYLE_LOCATION_NAVBAR_PLACEHOLDER(language)}`}
                classNameParent={`${STYLE_LOCATION_NAVBAR(language)}`}
                placeholder={TEXT_ADDRESS_SEARCH[language]}
                isNotCompleteProfile={isNotCompleteProfile}
              />
            </div> */}
            <div className={"ml-8 md:ml-0 xl:ml-17 hidden md:block"}>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  FunctionOpenInNewTab("http://wa.me/66925165458");
                }}
                className="flex w-fit my-auto cursor-pointer "
              >
                {/* <div
                  onClick={() => {
                    FunctionOpenInNewTab("http://wa.me/66925165458");
                  }}
                  className="w-12 h-12 cursor-pointer"
                > */}
                {/* <ICON_WhatApps /> */}
                <img
                  style={{
                    height: "28px",
                  }}
                  className="my-auto flex-row justify-center cursor-pointer"
                  src="/icons/whatapp.png"
                />
                {/* </div>{" "} */}
                <div className="my-auto ml-2 cursor-pointer text-gray-700 font-Poppins">
                  092-516-5458
                </div>
              </div>
            </div>
          </div>
          <img
            onClick={() => {
              if (!isNotCompleteProfile) {
                navigate("/");
              }
            }}
            src="/images/logo.png"
            className={isAddress ? `${STYLE_NAVBAR_LOGO}  ` : STYLE_NAVBAR_LOGO}
          />

          <div className={STYLE_FLEX_MENU_NAVBAR}>
            <div
              onClick={() => {
                if (user?._id) {
                  setOpenLogout(true);
                } else {
                  sessionStorage.setItem("redirect", location.pathname);
                  navigate("/Login");
                }
              }}
              className={`${STYLE_VIEWBOX_ICON} `}
            >
              {!loading && (
                <React.Fragment>
                  {user?._id ? (
                    <ICON_LOGOUT_GRAY
                      className={` ${STYLE_HOVER_BLUE} text-laundry-gray-100 w-[20px] h-[20px] group`}
                      className_arrow={STYLE_ARROW_RED}
                    />
                  ) : (
                    <ICON_LOGIN_GRAY
                      className={` ${STYLE_HOVER_BLUE}  text-laundry-gray-100 w-[22px] h-[22px] `}
                    />
                  )}
                </React.Fragment>
              )}
            </div>

            {openLogout && (
              <TemplateModal
                classNameModal={` w-modals_mb_logout  h-h_156 md:h-h_220 md:w-modals ${
                  language === "TH" ? "font-NotoSansThai" : "font-Poppins"
                }`}
                acceptText={
                  <div
                    className={`${
                      language === "TH" ? "text-base-th" : "text-base"
                    }`}
                  >
                    {TEXT_LOG_OUT[language]}
                  </div>
                }
                cancelText={
                  <div
                    className={`${
                      language === "TH" ? "text-base-th" : "text-base"
                    }`}
                  >
                    {TEXT_CANCEL[language]}
                  </div>
                }
                save={() => {
                  OnClickLogout(dispatch, navigate, location);
                }}
                showCloseButton={true}
                showSaveButton={true}
                open={openLogout}
                setOpen={setOpenLogout}
                panel={
                  <div
                    className={`${STYLE_PARENT_PANEL_MODAL} ${
                      language === "TH" ? "font-NotoSansThai" : "font-Poppins"
                    }`}
                  >
                    <div
                      className={`${
                        language === "TH" ? STYLE_HEADING_3_TH : STYLE_HEADING_3
                      } text-center mb-2  md:h-head_language  `}
                    >
                      {TEXT_LOG_OUT[language]}?
                    </div>
                    <div
                      className={` md:pt-4 pb-2.5 h-6 md:h-h_50 text-laundry-gray-80 text-center ${STYLE_BODY_3_REGULAR(
                        language
                      )}`}
                    >
                      {TEXT_ARE_YOU_SURE_LOGOUT[language]}
                    </div>
                  </div>
                }
              />
            )}
            <div className={` relative ${STYLE_VIEWBOX_ICON} `}>
              <Notification
                onClick={() => {
                  if (!isNotCompleteProfile && !isBasket) {
                    navigate("/Basket");
                  }
                }}
                count={cart?.length}
              />
              <ICON_BASKET
                onClick={() => {
                  if (!isNotCompleteProfile && !isBasket) {
                    navigate("/Basket");
                  }
                }}
                className={`text-laundry-gray-100 w-[22px] h-[22px] cursor-pointer ${STYLE_HOVER_BLUE}`}
              />
            </div>
            <div className={STYLE_VIEWBOX_ICON}>
              <ContextRenderChangeLanguage />
            </div>
            <BlueButton
              className={`${
                language === "TH" ? " text-sm-th " : " text-sm "
              } bg-laundry-primary-blue hover:bg-laundry-gray-80  rounded-lg text-white font-semibold shadow-md shadow-laundry-shadowblue hover:order-blue   focus:outline-none h-11 w-[140px] ml-6`}
              onClick={() => {
                if (!isNotCompleteProfile) {
                  navigate("/OurServices");
                }
              }}
              title={TEXT_CREATE_ORDER[language]}
            />
          </div>
        </div>
      </div>
    </div>
  );
});

const MobileNavbar = React.memo(({ isNotCompleteProfile }) => {
  const { cart } = React.useContext(ContextCart);
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = React.useState(false);
  const { user, loading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [openLogout, setOpenLogout] = React.useState(false);

  const isBasket = location.pathname === "/Basket";

  const { language, ContextRenderChangeLanguage } =
    React.useContext(ContextLanguage);

  const setSelectedLocation = StoreSelectedLocation(
    (state) => state.setSelectedLocation
  );

  const address = SystemStoreBasketAddress((state) => state.address);
  const setAddress = SystemStoreBasketAddress((state) => state.setAddress);

  React.useEffect(() => {
    if (!address) {
      AddressOnClickCurrentLocation(false, setSelectedLocation, setAddress);
    }
  }, [address]);

  return (
    <div className=" fixed z-50 w-full">
      <div className={STYLE_NAVBAR_MOBILE}>
        <div className={STYLE_VIEWBOX_ICON}>
          <ICON_MENU
            className={`w-[24px] cursor-pointer text-laundry-gray-100`}
            // onClick={() => setOpen(true)}
            onClick={() => {
              if (!isNotCompleteProfile) {
                setOpen(true);
              }
            }}
          />
          <DrawerMain open={open} setOpen={setOpen} />
        </div>

        <img
          onClick={() => {
            if (!isNotCompleteProfile) {
              navigate("/");
            }
          }}
          src="/images/logo.png"
          className={`${STYLE_NAVBAR_LOGO}  `}
        />

        <div className={STYLE_FLEX_MENU_NAVBAR}>
          <div
            onClick={() => {
              if (user?._id) {
                setOpenLogout(true);
              } else {
                sessionStorage.setItem("redirect", location.pathname);
                navigate("/Login");
              }
            }}
            className=" flex justify-center items-center"
          >
            {!loading && (
              <React.Fragment>
                {user?._id ? (
                  <ICON_LOGOUT_GRAY
                    className={` group-hover:text-laundry-primary-blue text-laundry-gray-100 w-[19px] h-[20.5px] `}
                    className_arrow={STYLE_ARROW_RED}
                  />
                ) : (
                  <ICON_LOGIN_GRAY
                    className={` text-laundry-gray-100  w-[19px] h-[20.5px] mx-3 cursor-pointer hover:text-laundry-primary-blue group`}
                  />
                )}
              </React.Fragment>
            )}
          </div>

          {openLogout && (
            // <TemplateModal
            //   classNameModal={` w-modals_mb_logout  h-h_156 md:h-h_220 md:w-modals ${
            //     language === "TH" ? "font-NotoSansThai" : "font-Poppins"
            //   }`}
            //   acceptText={TEXT_LOG_OUT[language]}
            //   cancelText={TEXT_CANCEL[language]}
            //   save={() => {
            //     OnClickLogout(dispatch, navigate, location);
            //   }}
            //   showCloseButton={true}
            //   showSaveButton={true}
            //   open={openLogout}
            //   setOpen={setOpenLogout}
            //   panel={
            //     <div
            //       className={`${STYLE_PARENT_PANEL_MODAL} ${
            //         language === "TH" ? "font-NotoSansThai" : "font-Poppins"
            //       }`}
            //     >
            //       <div
            //         className={`${
            //           language === "TH" ? STYLE_HEADING_3_TH : STYLE_HEADING_3
            //         } text-center mb-2 md:mb-4 md:h-head_language leading-6 md:leading-6.5 `}
            //       >
            //         {TEXT_LOG_OUT[language]}?
            //       </div>
            //       <div
            //         className={` md:pt-4 pb-2.5 h-6 md:h-h_50 text-laundry-gray-80 text-center ${STYLE_BODY_3_REGULAR(
            //           language
            //         )}`}
            //       >
            //         {TEXT_ARE_YOU_SURE_LOGOUT[language]}
            //       </div>
            //     </div>
            //   }
            // />
            <TemplateModal
              acceptText={
                <div
                  className={`${
                    language === "TH" ? "text-base-th" : "text-base"
                  }`}
                >
                  {TEXT_LOG_OUT[language]}
                </div>
              }
              cancelText={
                <div
                  className={`${
                    language === "TH" ? "text-base-th" : "text-base"
                  }`}
                >
                  {TEXT_CANCEL[language]}
                </div>
              }
              save={() => {
                OnClickLogout(dispatch, navigate, location);
              }}
              showCloseButton={true}
              showSaveButton={true}
              open={openLogout}
              setOpen={setOpenLogout}
              panel={
                <div
                  className={`${STYLE_PARENT_DELETE_PROGRAM} ${
                    language === "TH" ? "font-NotoSansThai" : "font-Poppins"
                  }  `}
                >
                  <div
                    className={`${
                      language === "TH"
                        ? STYLE_HEADING_3_BOLD_24_18_TH
                        : STYLE_HEADING_3_BOLD_24_18
                    } text-center h-h_30 `}
                  >
                    {TEXT_LOG_OUT[language]}?
                  </div>
                  <div
                    className={` py-3 md:pt-6 h-h_50 text-laundry-gray-80 text-center ${STYLE_BODY_3_REGULAR(
                      language
                    )}`}
                  >
                    {TEXT_ARE_YOU_SURE_LOGOUT[language]}
                  </div>
                </div>
              }
            />
          )}

          <div
            className={` relative w-11 h-11 flex justify-center ${
              user?._id ? " . ml-1 " : " -ml-1 "
            } -mr-1 items-center `}
          >
            <Notification
              onClick={() => {
                if (!isNotCompleteProfile && !isBasket) {
                  navigate("/Basket");
                }
              }}
              count={cart?.length}
            />
            <ICON_BASKET
              onClick={() => {
                if (!isNotCompleteProfile && !isBasket) {
                  navigate("/Basket");
                }
              }}
              className={`text-laundry-gray-100 w-[22px] hover:text-laundry-primary-blue cursor-pointer group`}
            />
          </div>
          <div className=" h-11 w-[54px] flex justify-center items-center">
            <ContextRenderChangeLanguage />
          </div>
        </div>
      </div>
    </div>
  );
});

const Navbar = ({ refScreen }) => {
  const isMobile = useIsMobile();
  const location = useLocation();

  const isNotCompleteProfile = location?.pathname === "/CompleteProfile";

  React.useEffect(() => {
    FunctionGetHistory(location);
    setTimeout(() => {
      document.getElementById("first-div")?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 300);
  }, [location]);

  return (
    <React.Fragment>
      {isMobile ? (
        <MobileNavbar isNotCompleteProfile={isNotCompleteProfile} />
      ) : (
        <DesktopNavbar
          refScreen={refScreen}
          isNotCompleteProfile={isNotCompleteProfile}
        />
      )}
    </React.Fragment>
  );
};
export default Navbar;
